export default "__VITE_ASSET__7L_QmPMJ__"